import {observer} from 'mobx-react'
import UI from '../stores/UI'

const Right = () => (
  <svg width="40px" height="21px" viewBox="0 0 40 21" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
    <polygon fill="#1C1D21" fillRule="nonzero" points="37.2765874 10.9718587 0 10.9718587 0 9.97185872 37.2647519 9.97185872 28 0.7071068 28.7071068 0 39.1848832 10.4777765 29.0911916 20.5714681 28.3840848 19.8643613"></polygon>
  </svg>
)

const Left = () => (
  <svg width="40px" height="21px" viewBox="0 0 40 21" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
    <polygon fill="#1C1D21" fillRule="nonzero" points="1.90829579 9.59960938 39.1848832 9.59960938 39.1848832 10.5996094 1.92013133 10.5996094 11.1848832 19.8643613 10.4777764 20.5714681 0 10.0936916 10.0936916 0 10.8007984 0.707106781"></polygon>
  </svg>
)

const Down = () => (
  <svg width="21px" height="40px" viewBox="0 0 21 40" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
    <polygon fill="#1C1D21" fillRule="nonzero" points="9.59960938 37.2765874 9.59960938 0 10.5996094 0 10.5996094 37.2647519 19.8643613 28 20.5714681 28.7071068 10.0936916 39.1848832 0 29.0911916 0.707106781 28.3840848"></polygon>
  </svg>
)

class Cursor extends React.Component {

  constructor(props) {
    super(props)
  }

  render() {

    const css = {
      display: UI.showArrow ? "block" : "none",
      position: 'fixed',
      top: UI.mouseY + 10,
      left: UI.mouseX + 10,
      zIndex: 1000
    }

    return (
      <div style={css}>
        {UI.showArrow === 'rarr' ? (
          <Right />
        ) : UI.showArrow === 'larr' ? (
          <Left />
        ) : UI.showArrow === 'darr' ? (
          <Down />
        ) : null}
      </div>
    )
  }
}

export default observer(Cursor)



// WEBPACK FOOTER //
// ./app/javascript/packs/components/Cursor.js